import type { State } from '../../types';
import type { PersonalDataItemViewModelExtended } from './personal-data-item-view-model-extended';

import { toList } from '../toList';

export function personalDataItemsNotDeleted(state: State): PersonalDataItemViewModelExtended[] {
  if (state.organization === undefined) return [];
  return toList(state.organization.personalDataItemsById)
    .filter((e) => !e.deleted)
    .map((x) => {
      return {
        ...x,
        storageUnitComputer: undefined,
        alerts: [],
      };
    });
}
